import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Overview from './components/views/Overview';
import Catalog from './components/views/Catalog';
import Lineage from './components/views/Lineage';
import Access from './components/views/Access';
import FAQ from './components/views/FAQ';
import HowItWorks from './components/views/HowItWorks';
import Placeholder from './components/views/Placeholder';

export default function App() {
  const [currentView, setCurrentView] = useState('overview');

  const renderView = () => {
    switch (currentView) {
      case 'overview': return <Overview />;
      case 'how-it-works': return <HowItWorks />;
      case 'catalog': return <Catalog />;
      case 'lineage': return <Lineage />;
      case 'access': return <Access />;
      case 'faq': return <FAQ />;
      case 'quality': return <Placeholder title="Quality Beacons" />;
      case 'glossary': return <Placeholder title="Schema Glossary" />;
      case 'analytics': return <Placeholder title="Usage Sonar" />;
      default: return <Overview />;
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[var(--bg-ocean)] selection:bg-[var(--schema-teal)] selection:text-[var(--bg-ocean)]">
      <Sidebar currentView={currentView} setCurrentView={setCurrentView} />
      
      <div className="flex-1 flex flex-col relative overflow-hidden">
        {/* Futuristic Background Glow */}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[var(--schema-teal)] rounded-full mix-blend-screen filter blur-[150px] opacity-[0.03] pointer-events-none"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[var(--schema-teal)] rounded-full mix-blend-screen filter blur-[150px] opacity-[0.02] pointer-events-none"></div>
        
        <Header />
        
        <main className="flex-1 overflow-auto p-4 md:p-8 relative z-10">
          <div className="max-w-7xl mx-auto h-full">
            {renderView()}
          </div>
        </main>
      </div>
    </div>
  );
}